/*
AJAXy business to handle cached environment
*/

function onHaveUserData() {
    var data = JSON.parse(sessionStorage.getItem(window.storageSessionKey));

    // show stuff based on logged in status
    if (data.loggedIn) {
        $('.logged-in-show').removeClass('logged-in-show');
    } else {
        $('.logged-out-show').removeClass('logged-out-show');
    }
}

function onHaveCartData() {
    var data = JSON.parse(sessionStorage.getItem(window.storageCartKey));

    $('#mini-cart .contents').html(data);
    helpers.removeMiniCartFocus();

    let items = $('#mini-cart .contents').find('.mini_cart_item');

    $('#mini-cart-open .count').text(items.length);
    // show stuff based on cart count
    if (items.length === 0) {
        $('.empty-cart-show').removeClass('empty-cart-show');
    } else {
        $('.filled-cart-show').removeClass('filled-cart-show');
    }

}

function fetchUserData() {
    $.ajax({
        method: 'post',
        url: "/wp-admin/admin-ajax.php",
        data: {
            'action': 'millborn_get_user_data'
        },
        success: function (data) {
            sessionStorage.setItem(window.storageSessionKey, data);
        },
        complete: function () {
            onHaveUserData();
        }
    });
}

function fetchCartData() {
    $.ajax({
        method: 'get',
        url: window.cartUrl,
        success: function (data) {
            let minicart = $(data).find('#mini-cart .contents').html().replace(/[\n\t]/g, ''); // replace probably isn't needed here, just kinda nice to remove newline and tab characters
            sessionStorage.setItem(window.storageCartKey, JSON.stringify(minicart));
        },
        complete: function () {
            onHaveCartData();
        }
    });
}

if (sessionStorage.getItem(window.storageSessionKey)) {
    onHaveUserData();
} else {
    fetchUserData();
}

if (sessionStorage.getItem(window.storageCartKey)) {
    onHaveCartData();
} else {
    fetchCartData();
}

$b.on('updated_cart_totals wc_cart_emptied', function () {
    sessionStorage.removeItem(window.storageCartKey);
    fetchCartData();
});
